import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuardService } from "@app/core";
import { PresetManagerComponent } from "@app/view/data-view/preset-manager/preset-manager.component";

const routes: Routes = [
  {
    path: "view",
    component: PresetManagerComponent,
    data: { title: "scheduler.menu.data-view" },
    canActivate: [AuthGuardService]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DataViewRoutingModule {}
